import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: ['M15.17 7.54l-.708-.706-5.752 5.752-2.004-2.004-.707.707L8.71 14z'],
  height: 20,
  width: 20,
});
